import React from "react";
import styled from "styled-components";
import { palette } from "styled-theme";

const Svg = styled.svg`
  path {
    fill: ${palette("alertTwo", 0)};
  }
`;

export const CircleAlert = ({className}) => (
  <Svg className={className} width="61" height="60" viewBox="0 0 61 60" xmlns="http://www.w3.org/2000/svg">
    <path d="M.5 30c0 16.541 13.459 30 30 30s30-13.459 30-30-13.459-30-30-30S.5 13.459.5 30zm27.123 14.975V39.41h5.754v5.564h-5.754zm0-9.725V14.069h5.754v21.18h-5.754z" fill="#00673E" fillRule="evenodd"/>
  </Svg>
);
